import { useRef, useCallback } from 'react';

function useOnce(callback) {
  const isCalled = useRef(false);
  const onceCallback = useCallback(
    (...params) => {
      if (isCalled.current === false) {
        isCalled.current = true;
        callback(...params);
      }
    },
    [callback]
  );
  return onceCallback;
}

export { useOnce as default };
//# sourceMappingURL=useOnce.mjs.map
